// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"d73405d8","787":"e800241b"}[chunkId] + ".chunk.js";
};